import KoIcon from '@kwapio/icons';
import PhoneInput from 'antd-phone-input';
import { KoButton, KoDP, KoSkeleton, KoText, KoTitle } from 'packages';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './myteams.module.scss';
import TeamCalendar from './teamCalendar';

export default function MyTeams() {
  const users = useSelector(state => state.users);
  const [loadingCards ] = useState(false);
  console.log(users);
  const dynamicCards = [
    {
      label: 'Total Members',
      icon: 'UsersFilled',
      arrow: 'ArrowLineUpFilled',
      description: 'All active workspace members',
      value: `1`
    },
    {
      label: 'Off Today',
      icon: 'RevenueFilled',
      value: `3`,
      description: 'Total created project tasks',
      arrow: 'ArrowLineUpFilled'
    },
    {
      label: 'Work from Home',
      icon: 'ClockFilled',
      value: `23`,
      description: 'Overall task in progress rate',
      arrow: 'ArrowLineUpFilled',
      progress: 30
    }
         
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentBox}>
        {
          !loadingCards && dynamicCards.length > 0 && dynamicCards.map((i) => <div key={i} className={styles.card}>
            <div className={styles.icon}>
              <KoIcon name={i.icon} width={46} height={46} />
            </div>
            <div className={styles.mycontent}>
              <KoText className={styles.label} text={i.label} />
              <KoTitle level={1} className={styles.value} text={i.value} />
            </div>
          </div>)
        }
        {
          loadingCards && [1, 2, 3, 4, 5, 6, 7].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
        }
      </div>
      <KoTitle text='Team Calendar' level={4} className={styles.header} />
      <TeamCalendar users={users['data']} />
      <KoTitle text='Direct Reports' level={4} className={styles.header} />
      <div className={styles.profileBodyContnet}>
        {users['data']?.map((item,i) =>
          <div  key={item?.userId} className={styles.profileCard}>
            <div className={styles.profileList}>
              <div className={styles.userWrapper } >
                <div className={`${styles.headCircle}  ${styles[item?
                  item?.profile?.firstName?.charAt(0).toLowerCase() :'a']}`}>

                  {item?.profile?.['logo'] ?
                      
                    <KoDP logo={item?.profile?.logo} width={item?.profile?.logo?.[0]?.name ? 30 : 25} height={item?.profile?.logo?.[0]?.name ? 30 : 25} shape={'circle'} userId={item?.userId} userDetails={item} name={item?.profile?.logo?.[0]?.name} />
                    :
                    <KoText className={`${styles.letter}`} text={item?.profile?.firstName?.charAt(0)}/>
                  }
                </div>
              </div>
              <div className={styles.profileInfo}>
                <div className={styles.details}>
                  <KoTitle level={5} ellipsis={true} text={`${item?.profile?.firstName} ${item?.profile?.lastName}`} />
                  <PhoneInput className={`${styles.mobile} mobileNo`} value={item?.mobile} disableDropdown readOnly />
                </div>
              </div>
            </div>
            <div className={styles.icons}>
              <KoButton iconBtn={true} shape="circle" icon={<KoIcon name='EmailOutlined'  width={17} height={16}/>} />
              <KoButton iconBtn={true} shape="circle" icon={<KoIcon name='ChatOutlined'  width={17} height={16}/>} />
              <KoButton iconBtn={true} shape="circle" icon={<KoIcon name='OpenOutlined'  width={17} height={16}/>} />
            </div>

          </div>
        )}
      </div>
    </div>
  );
}
